<template>
    <form @submit.prevent="submit">
        <!-- Card Start -->
        <div class="card mb-2">
            <h4 class="title text-24 lh-base mb-2 fw-semibold">Contact Details</h4>
            <div class="bg-white p-3 radius-8">
                <div class="row gy-4">
                    <Input
                        v-model="data.factory_name"
                        input-id="factory_name"
                        title="Name of the factory/client"
                        field="data.factory_name"
                        :req="true"
                        :bootstrap="true"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        placeholder="Enter factory/client"
                    />
                    <Input
                        v-model="data.representative_name"
                        input-id="representative_name"
                        title="Enter Client’s representative name"
                        field="data.representative_name"
                        :req="true"
                        :bootstrap="true"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        placeholder=" Factory’s/Client’s representative name"
                    />
                    <DatePicker
                        v-model="data.service_date"
                        field="data.service_date"
                        title="Service Date"
                        placeholder="DD/MM/YYYY"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        :bootstrap="true"
                        :disabled="true"
                    />

                    <Input
                        v-model="data.designation"
                        input-id="designation"
                        title="Designation"
                        field="data.designation"
                        :req="true"
                        :bootstrap="true"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        placeholder="Enter Designation"
                    />

                    <Input
                        v-model="data.email"
                        input-id="email"
                        title="Contact e-mail address"
                        field="data.email"
                        :req="true"
                        :bootstrap="true"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        placeholder="Enter Email Address"
                    />

                    <Input
                        v-model="data.p_number"
                        input-id="p_number"
                        title="Contact mobile number"
                        field="data.p_number"
                        :req="true"
                        :bootstrap="true"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        placeholder="Enter Phone no"
                    />

                    <Input
                        v-model="data.address"
                        input-id="address"
                        title="Address"
                        field="data.address"
                        :req="true"
                        :bootstrap="true"
                        col="col-12"
                        otherClass="form-group"
                        placeholder="Enter Address"
                    />
                </div>
            </div>
        </div>
        <!-- Card Start -->
        <div class="card mb-2">
            <h4 class="title text-24 lh-base mb-2 fw-semibold">Client/Factory Details</h4>
            <div class="bg-white p-3 radius-8">
                <div class="row g-3">
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group">
                            <label class="text-18" for="male">Number of employees</label>
                            <div class="row g-3">
                                <Input
                                    v-model="data.male"
                                    input-id="male"
                                    title=""
                                    field="data.male"
                                    :req="false"
                                    :bootstrap="true"
                                    col="col-lg-6 col-md-6"
                                    otherClass="form-group"
                                    placeholder="Male"
                                />
                                <Input
                                    v-model="data.female"
                                    input-id="female"
                                    title=""
                                    field="data.female"
                                    :req="false"
                                    :bootstrap="true"
                                    col="col-lg-6 col-md-6"
                                    otherClass="form-group"
                                    placeholder="Female"
                                />
                            </div>
                        </div>
                    </div>
                    <Input
                        v-model="data.no_shift"
                        input-id="no_shift"
                        title="Number of shifts"
                        field="data.no_shift"
                        :req="true"
                        :bootstrap="true"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        placeholder="Enter Number of shifts"
                    />
                    <Input
                        v-model="data.factory_area"
                        input-id="factory_area"
                        title="Area of the factory (sqm/sqf)"
                        field="data.factory_area"
                        :req="true"
                        :bootstrap="true"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        placeholder="Enter Area of the factory"
                    />
                    <Input
                        v-model="data.production_capacity"
                        input-id="production_capacity"
                        title="Production Capacity (Pcs)"
                        field="data.production_capacity"
                        :req="true"
                        :bootstrap="true"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        placeholder="Enter production capacity (Pcs)"
                    />
                    <Input
                        v-model="data.production_process"
                        input-id="production_process"
                        title="Major Production processes"
                        field="data.production_process"
                        :req="true"
                        :bootstrap="true"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        placeholder="Enter Major Production processes"
                    />
                    <Input
                        v-model="data.weekend"
                        input-id="weekend"
                        title="Weekend (s)"
                        field="data.weekend"
                        :req="true"
                        :bootstrap="true"
                        col="col-lg-6 col-md-6"
                        otherClass="form-group"
                        placeholder="Eg. Friday, Saturday, Sunday, ....."
                    />
                </div>
            </div>
        </div>
        <!-- Card Start -->
        <div class="card mb-2" v-for="(service, index) in allServiceData" :key="index">
            <div class="form-check mb-3">
                <div class="">
                    <label class="title text-24 lh-base mb-0 fw-semibold form-check-label" for="higg">
                        {{ service.service?.title ?? '' }}
                    </label>
                    <p class="desc mt-2 m-0">Please put tick (✔) mark to your required service</p>
                </div>
                <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="higg"
                    :checked="openFormIds.includes(service.id)"
                    @click="toggleForm(service)"
                />
            </div>
            <template v-if="openFormIds.includes(service.id)">
                <HIggForm
                    v-if="service.form_style === 'higg'"
                    :service="service"
                    :responses="serviceResponses[service.id]"
                />
                <SlcpForm
                    v-if="service.form_style === 'slcp'"
                    :service="service"
                    :responses="serviceResponses[service.id]"
                />
                <IsoForm
                    v-if="service.form_style === 'iso'"
                    :service="service"
                    :responses="serviceResponses[service.id]"
                />
                <SustainabilityForm
                    v-if="service.form_style === 'sustainability'"
                    :service="service"
                    :responses="serviceResponses[service.id]"
                />
            </template>
        </div>
        <div class="col-12 d-flex gap-3 justify-content-end mt-30">
            <Button title="Submit" loaderClass="rs-btn rs-btn-primary mw-20 w-100 disabled" btnClass="rs-btn rs-btn-primary mw-20 w-100" loadingText="Please wait" :bootstrap="true"/>
        </div>
    </form>
</template>
<script setup>
import { reactive, ref, onBeforeMount, toRaw, getCurrentInstance } from 'vue'
const { proxy } = getCurrentInstance()
const today = new Date();
const data = reactive({
    factory_name: '',
    representative_name: '',
    service_date: today.toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    }),
    designation: '',
    email: '',
    p_number: '',
    address: '',
    male: '',
    female: '',
    no_shift: '',
    factory_area: '',
    production_capacity: '',
    production_process: '',
    weekend: '',
})
const allServiceData = ref([]);
const openFormIds = ref([]);
const serviceResponses = reactive({});

const checkboxChildrenByParent = (service, parentValue) => {
    const checkboxList = Array.isArray(service.service_checkbox)
        ? service.service_checkbox
        : Object.values(service.service_checkbox || {});

    const parent = checkboxList.find(checkbox => checkbox.checkbox_value === parentValue);
    if (!parent) return [];

    return Array.isArray(parent.children)
        ? parent.children
        : Object.values(parent.children || {});
};

const buildIsoCheckboxAnswers = (service, parentValue, convertedCheckboxes) => {
    return checkboxChildrenByParent(service, parentValue).map(child => ({
        id: child.id,
        checkbox_value: child.checkbox_value,
        answer: convertedCheckboxes[child.checkbox_value] ?? 'No'
    }));
};

const submit = async () => {
    // Convert the comma-separated string into an array
    const weekendArray = data.weekend.split(',').map(d => d.trim()).filter(d => d.length > 0);
    const payload = openFormIds.value.map(serviceId => {
        const service = allServiceData.value.find(s => s.id === serviceId);
        const rawData = toRaw(serviceResponses[serviceId]);

        // Convert booleans → Yes/No
        const convertedCheckboxes = {};
        Object.keys(rawData.checkboxes).forEach(key => {
            convertedCheckboxes[key] = rawData.checkboxes[key] ? "Yes" : "No";
        });

        const serviceData = {
            ...rawData,
            checkboxes: convertedCheckboxes
        };

        if (service.form_style === 'iso') {
            serviceData.iso_checkboxes = buildIsoCheckboxAnswers(service, 'isoCheckboxes', convertedCheckboxes);
            serviceData.audit_checkboxes = buildIsoCheckboxAnswers(service, 'auditCheckboxes', convertedCheckboxes);
        }

        return {
            service_id: service.id,
            service_title: service.service?.title ?? "",
            service_data: serviceData
        };
    });
    const requestData = {
        data: {
            ...data,
            weekend: weekendArray
        },
        serviceData: payload
    };

    try {
       const res = await proxy.store('/service-book/store', requestData);
       if(res === true) {
           formReset();
           await Swal.fire({
               title: '<span style="color:#047857;font-weight:700;">Thank You</span>',
               html: `
                   <div style="text-align:center;padding:8px 4px 2px;">
                       <p style="font-size:1.05rem;line-height:1.6;font-weight:600;color:#1f2937;margin:0 0 14px;">
                           Your service request has been submitted successfully.
                       </p>

                       <div style="margin:14px 0;padding:16px;background:#ecfdf5;border:1px solid #a7f3d0;border-radius:10px;">
                           <p style="color:#047857;font-size:1rem;font-weight:700;margin:0 0 7px;">
                               Request Received
                           </p>
                           <p style="color:#065f46;font-size:0.93rem;line-height:1.55;margin:0;">
                               Our team has received your information and will review your request carefully. We will contact you shortly with the next steps.
                           </p>
                       </div>

                       <p style="font-size:0.9rem;line-height:1.5;color:#6b7280;margin:12px 0 0;">
                           A confirmation email will be sent if your email address was provided correctly.
                       </p>
                   </div>
               `,
               icon: 'success',
               confirmButtonColor: '#059669',
               confirmButtonText: 'OK, Got It',
               allowOutsideClick: true,
               allowEscapeKey: true,
               customClass: {
                   popup: 'service-request-success-alert'
               }
           });

       }
    } catch (error) {
        $toast('Submission failed','error')
        console.error('Submission error:', error);
    }

}

const formReset = () => {
    Object.keys(data).forEach(key => {
        data[key] = typeof data[key] === 'string' ? '' : (data[key] === null ? null : '');
    });
    // data.service_date = null;

    openFormIds.value = [];

    Object.keys(serviceResponses).forEach(serviceId => {
        const responseObj = serviceResponses[serviceId];

        Object.keys(responseObj.inputs || {}).forEach(k => {
            responseObj.inputs[k] = null;
        });

        Object.keys(responseObj.dates || {}).forEach(k => {
            responseObj.dates[k] = null;
        });

        Object.keys(responseObj.checkboxes || {}).forEach(k => {
            responseObj.checkboxes[k] = false;
        });

        if (responseObj.table_answers) {
            Object.keys(responseObj.table_answers).forEach(q => {
                responseObj.table_answers[q] = null;
            });
        }
    });
};
const toggleForm = (service) => {
    const index = openFormIds.value.indexOf(service.id);
   if (index > -1) {
       openFormIds.value.splice(index, 1);
   }else {
       openFormIds.value.push(service.id);
   }
    if (!serviceResponses[service.id]) {
        serviceResponses[service.id] = {
            inputs: {},
            checkboxes: {}
        };

        if (service.form_style === 'higg') {
            serviceResponses[service.id].table_answers = {};
        }
    }
}

const getServiceList = async () => {
    const {data: res} = await axios.get('/web/get-all-service');
    allServiceData.value = res;

    res.forEach(item => {
        const responseObj = {
            inputs: {},
            checkboxes: {},
            dates: {}
        };

        // HIGG table answers
        if (item.form_style === 'higg') {
            responseObj.table_answers = {};
            item.service_request_table?.service_table_details?.forEach(q => {
                responseObj.table_answers[q.question] = null;
            });
        }

        item.service_input?.forEach(input => {
            responseObj.inputs[input.input_value] = null;
        });

        item.service_date?.forEach(date => {
            responseObj.dates[date.date_value] = null;
        });

        // Checkboxes
        const checkboxList = Array.isArray(item.service_checkbox)
            ? item.service_checkbox
            : Object.values(item.service_checkbox || {});

        checkboxList.forEach(cb => {
            const children = Array.isArray(cb.children)
                ? cb.children
                : Object.values(cb.children || {});
            children.forEach(child => {
                responseObj.checkboxes[child.checkbox_value] = false;
            });
        });

        serviceResponses[item.id] = responseObj;
    });
}


onBeforeMount(() => {
    getServiceList();
})
</script>
